export const paperReviewTabs = [
    {
      id: 1,
      label: "심사위원 1",
    },
    {
      id: 2,
      label: "심사위원 2",
    },
    {
      id: 3,
      label: "심사위원 3",
    },
  ];
  
  export const submissionTabs = {
    agreement: {
      label: "동의",
      id: "agreement",
    },
    review: {
      label: "심사 정보",
      id: "review",
    },
    author: {
      label: "저자 정보 입력",
      id: "author",
    },
    content: {
      label: "투고 정보 입력",
      id: "content",
    },
  };

  export const submissionDetailTabs = {
    agreement: {
      label: "동의",
      id: "agreement",
    },
    review: {
      label: "심사 정보",
      id: "review",
    },
    author: {
      label: "저자 정보",
      id: "author",
    },
    content: {
      label: "투고 정보",
      id: "content",
    },
  };